/* unplugin-vue-components disabled */import script from "./Particle.vue?vue&type=script&lang=ts&setup=true"
export * from "./Particle.vue?vue&type=script&lang=ts&setup=true"

import "./Particle.vue?vue&type=style&index=0&id=6ec0c216&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ec0c216"]])

export default __exports__